import React, {useEffect} from "react";
import {  useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import {
  FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS,
  FEATURE_TOGGLE_INCASSA_SUBITO,
  FEATURE_TOGGLE_ASK,
  FEATURE_TOGGLE_TSPAY_ONBOARDING
} from "../../config";

import { getCheckupSummary } from "../../store/actions/rating/index";
import {
  getKpiList,
  getKpiTitles,
  isBusinessPerformanceActive
} from "../../store/actions/analytics/index";
import {
  getPrivacyIncassaSubito,
  getTotalEligibleInvoices
} from "../../store/actions/incassaSubito";
import { getTotalsCompany } from "../../store/actions/statistics";
import { getLastEInvoices } from "../../store/actions/dashboard";

import {
  getArrayStringFromArrayObject,
  getValueFromInvoice
} from "../../libs/utils";
import {
  getAllBusinessPerformancePermissions,
  getVolDAffariSettings
} from "../../libs/settingsUtils";
import { usePermissions } from "../../customHooks";

import { FormattedMessage } from "react-intl";

import AnalyticsChart from "../analytics/index";
import BoxChart from "./boxChart";
import BoxRecentInvoices from "./boxRecentInvoices";
import TsPayOnboardingBanner from "../tspay/onboarding/onboardingBanner";
import WidgetAsk from "../ask/widgets/widgetCommercialista";
import WidgetCompanyDeadlines from "../deadlines/widgetCompany";
import WidgetIncassaSubito from "../widget/widgetIncassaSubito";
import WidgetSummaryCheckupImpresa from "../widget/WidgetSummaryCheckupImpresa";
import WidgetTotalDocsNew from "../widget/widgetTotalDocsNew";

import "./style.css";

const DashCliente = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const currentYear = new Date().getFullYear();
  const lastYear = currentYear - 1;

  const analytics = useSelector(state => state.analytics);
  const auth = useSelector(state => state.auth);
  const currentPermissions = useSelector(state => state.currentPermissions);
  const studio = useSelector((state) => state.studio);
  const dashboard = useSelector(state => state.dashboard);
  const incassaSubito = useSelector(state => state.incassaSubito);
  const main = useSelector(state => state.main);
  const services = useSelector(state => state.servicesAgyo);
  const company = useSelector((state) => state.company);
  const statistics = useSelector(state => state.statistics);
  const surveys = useSelector(state => state.ask.surveys);
  const tsPayConfig = useSelector(state => state.tspay.configStatus);

  const companySelected = main.companySelected;
  const clientIdSelected = main.clientIdSelected;
  const accountantSelected = main.accountantSelected;
  const accountantIdSelected=main.accountantIdSelected;
  const myType = main.myType;
  const totals = statistics.totals;
  const isGettingStatistics = statistics.isGettingStatistics;

  const onBoardingData = tsPayConfig?.data;
  const onBoardingStatus = onBoardingData?.status;
  const isGettingLastEInvoices = dashboard.isGettingLastEInvoices;
  const lastEInvoices = dashboard.lastEInvoices;

  let studioFind;

  if (main?.accountantUuidSelected) {
    studioFind = studio?.list?.find((x) => x.uuid === main?.accountantUuidSelected) ||
    company?.companies?.find(x => x?.uuid === main?.companyUuidSelected)?.commercialistiList?.find(x => x?.uuid === main?.accountantUuidSelected);
  }

  const { isPermissionDocumentInvoices, isPermissionDeadlines, isPermissionAsk,
    isPermissionCheckup, isPermissionAnalytics,
    isPermissionIncassaSubito, isPermissionCosti,
    isPermissionVolDaffari } = usePermissions(currentPermissions);

  useEffect(() => {
    if (!companySelected || !accountantSelected || !auth) {
      return;
    }

    if (window.aptrinsic) {
      window.aptrinsic("track", "digital-box:HOME-COMPANY");
    }

    dispatch(getCheckupSummary());
  }, []);

  useEffect(() => {
    if (!clientIdSelected || !accountantIdSelected || !auth) {
      return;
    }

    dispatch(getTotalsCompany());
    dispatch(getLastEInvoices());
    if (
      FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" &&
      myType !== "PERSON"
    ) {
      dispatch(getKpiList());
      dispatch(getKpiTitles());
      dispatch(isBusinessPerformanceActive());
    }
    if (FEATURE_TOGGLE_INCASSA_SUBITO === "true" && myType !== "PERSON") {
      dispatch(getTotalEligibleInvoices());
      dispatch(getPrivacyIncassaSubito());
    }

  }, [auth, clientIdSelected, accountantIdSelected]);

  const goToOtherDeadlinesSubjective = () => {
    navigate({
      pathname: "/scadenzecliente",
      state: {
        viewType: "calendar"
      }
    });    
  };

  const retrieveTotalByType = (typeProperty, yearFilter) => {
    let calcolatedValue = 0;
    try {
      if (totals && totals.results) {
        calcolatedValue = totals.results.find(el => {
          return el.year === yearFilter;
        })[typeProperty];
        if (calcolatedValue)
          calcolatedValue = calcolatedValue
            .toString()
            .replace(".", "")
            .replace(",", ".");
        else calcolatedValue = "0";
      }
    } catch (e) {
      calcolatedValue = 0;
    }
    return calcolatedValue;
  };

  const renderCosti = () => {

    let thisSetCosts =
      totals && totals.results
        ? totals.results.find(el => {
          return el.year === currentYear;
        })
        : null; // prende il set di costi di quest' anno

    let dataChartCosti =
      thisSetCosts && thisSetCosts.costDetails
        ? getArrayStringFromArrayObject(
          thisSetCosts.costDetails,
          "description",
          "amount"
        )
        : [];

    let currentCosts = retrieveTotalByType("costs",
      currentYear);
    let lastCosts = retrieveTotalByType("costs", lastYear);
    let percCosts =
      parseFloat(lastCosts) > 0
        ? ((parseFloat(currentCosts) - parseFloat(lastCosts)) /
          parseFloat(lastCosts)) *
        100
        : 0;

    return isPermissionCosti ? (
      <BoxChart
        tabbed={false}
        tabTitle1={"Costi"}
        tabTitle2={null}
        dataChart1={dataChartCosti}
        dataChart2={null}
        keyCanvas="costi"
        title={
          <h2 className="cardTitle">
            <FormattedMessage id="widgets.costs.title" />
            <div className="cardSubtitle"><FormattedMessage id="widgets.costs.title2" /></div>
          </h2>
        }
        isFooter={true}
        classOverlay="containerOverlay3col"
        total1={currentCosts}
        total2={lastCosts}
        perc={percCosts.toString()}
        isSpinner={isGettingStatistics}
      />
    ) : null;
  };

  /*
  const renderImposte = () => {
    let currentTaxes = retrieveTotalByType("taxes",
      currentYear);
    let lastTaxes = retrieveTotalByType("taxes", lastYear);
    let percTaxes =
      parseFloat(lastTaxes) > 0
        ? ((parseFloat(currentTaxes) - parseFloat(lastTaxes)) /
          parseFloat(lastTaxes)) *
        100
        : 0;

    return FEATURE_TOGGLE_IMPOSTE === "true" && isPermissionImposte ? (
      <BoxChart
        tabbed={true}
        tabTitle1={"Pagate"}
        tabTitle2={"Da pagare"}
        dataChart1={null}
        dataChart2={null}
        keyCanvas="imposte"
        title={
          <h2
            className="cardTitle"
            style={{
              fontSize: "30px",
              color: "rgb(42,157,214)",
              fontWeight: "300"
            }}
          >
            Totale imposte
            <div className="cardSubtitle">da inizio anno</div>
          </h2>
        }
        isFooter={true}
        classOverlay="containerOverlay3col"
        total1={currentTaxes}
        total2={lastTaxes}
        perc={percTaxes.toString()}
      />
    ) : null;
  };
  */

  const renderAnalytics = () => {
    let titleDef = "";
    let kpiDef = "";
    let parentId = "";
    const customerKpiPermissionList = [];
    let analyticsPermissions = [];
    if (
      (!isPermissionAnalytics && !isPermissionVolDaffari) ||
      !analytics ||
      !analytics.kpiList.status.ended ||
      !analytics.kpiTitles.status.ended
    )
      return null;

    if (isPermissionAnalytics) {
      analyticsPermissions = analyticsPermissions.concat(getAllBusinessPerformancePermissions(currentPermissions));
    }

    if (isPermissionVolDaffari) {
      analyticsPermissions = analyticsPermissions.concat(getVolDAffariSettings(currentPermissions));
      kpiDef = "FatturatoFiscaleMensile";
    }

    if (analyticsPermissions.length > 0) {
      for (let p = 0; p < analyticsPermissions.length; p++) {
        if (analyticsPermissions[p].isActive === true) {
          customerKpiPermissionList.push(analyticsPermissions[p].functionSmallLabel);
          if (!kpiDef) {
            kpiDef = analyticsPermissions[p].functionSmallLabel;
          }
        }
      }

      const kpiData = analytics.kpiList.data.data;
      const dictionaryTitles = analytics.kpiTitles.data;
      for (let amb = 0; amb < kpiData.length; amb++) {
        let kpiCategories = kpiData[amb]["kpiScopes"];
        for (let x = 0; x < kpiCategories.length; x++) {
          for (let i = 0; i < kpiCategories[x].kpis.length; i++) {
            if (kpiCategories[x].kpis[i].url === kpiDef) {
              // se il padre non è un kpi numerico prendo lui stesso
              if (kpiCategories[x].kpis[i].kpiType.id.toString() === "1") {
                parentId = kpiCategories[x].kpis[i].id;
              } else {
                titleDef = kpiCategories[x].kpis[i].title;
              }
            }
          }
        }
      }
      // se il padre è un kpi numerico cerco il primo figlio
      if (parentId && !titleDef) {
        for (let amb = 0; amb < kpiData.length; amb++) {
          let kpiCategories = kpiData[amb]["kpiScopes"];
          for (let x = 0; x < kpiCategories.length; x++) {
            for (let i = 0; i < kpiCategories[x].kpis.length; i++) {
              if (kpiCategories[x].kpis[i].parentId === parentId) {
                kpiDef = kpiCategories[x].kpis[i].url;
                titleDef = kpiCategories[x].kpis[i].title;
              }
            }
          }
        }
      }
      const analyticsTitleSplit = titleDef ? titleDef.split(".") : [];
      let kpiT = null;
      analyticsTitleSplit.map(el => {
        kpiT = kpiT ? kpiT[el] : dictionaryTitles ? dictionaryTitles[el] : "";
        return kpiT;
      });

      return FEATURE_TOGGLE_CUSTOMERS_DASH_ANALYTICS === "true" &&
        customerKpiPermissionList &&
        customerKpiPermissionList.length > 0 ? (
          <AnalyticsChart
            classChart=""
            idDivForChart="analyticsView-chart"
            fromDashCliente={true}
            customerKpiPermission={customerKpiPermissionList}
            kpiName={kpiDef}
            kpiTitle={kpiT}
            kpiType={9}
          />
        ) : null;
    }
    return undefined;
  };

  const renderIncassaSubito = () => {
    return (
      FEATURE_TOGGLE_INCASSA_SUBITO === "true" &&
      isPermissionIncassaSubito && (
        <WidgetIncassaSubito
          incassaSubito={incassaSubito}
          clientIdSelected={clientIdSelected}
        />
      )
    );
  };

  const getInvoicesArray = (docs, field) => {
    let invoices = [];
    for (let i = 0, ci = docs.length; i < ci; ++i) {
      let invoiceId = docs[i].documentId;
      let date = getValueFromInvoice(docs[i].infoList, "Data documento");
      let importo = getValueFromInvoice(docs[i].infoList, "Importo");
      // il fornitore si trova in subtitle ma dobbiamo togliere la stringa iniziale
      let ragSoc = docs[i].subtitle.replace(/Fattura ricevuta da /g, "");
      let numeroFattura = getValueFromInvoice(docs[i].infoList,
        "Numero fattura");
      if (ragSoc.length > 30) {
        ragSoc = ragSoc.substring(0, 30) + "...";
      }
      const startLine1 = field === "cedentePrestatoreRagSoc" ? "Da: " : "A: ";
      let item = {
        invoiceId: invoiceId,
        data: date,
        lines: {
          line1: startLine1 + (ragSoc ? ragSoc : "-") + ",",
          line2:
            (numeroFattura ? numeroFattura : "-") +
            " DEL " +
            (date ? date : "-")
        }
      };
      // if importo is not null
      if (importo.trim().length) {
        let newImport = importo.replace(".", "").replace(",", ".");
        item.lines.line3 =
          new Intl.NumberFormat("it-IT", {
            style: "decimal",
            currency: "EUR",
            minimumFractionDigits: 2,
            maximumFractionDigits: 2
          }).format(parseFloat(newImport)) + " €";
      }
      invoices.push(item);
    }
    return invoices;
  };

  const renderCheckupWidget = (index, title) => {
    return (
      <div><WidgetSummaryCheckupImpresa
        index={index}
        title={title}        
      />
      </div>);
  };

  let passiveInvoices = [];
  if (lastEInvoices && lastEInvoices.active && lastEInvoices.passive) {
    passiveInvoices = getInvoicesArray(lastEInvoices.passive,
      "cedentePrestatoreRagSoc");
  }

  const isOnboardingToShow =
    typeof onBoardingStatus !== "undefined" && onBoardingStatus === "NOT_LINKED";

  let allCompanyServices = {};
  let companyHasCheckupImpresa = false;
  if (
    !services?.allCompanyServices.status.started &&
      services?.allCompanyServices.status.ended &&
      services?.allCompanyServices?.status?.list
  ) {
    allCompanyServices = services?.allCompanyServices.status.list;
  }
  for (let service in allCompanyServices){
    if (allCompanyServices[service] && (allCompanyServices[service].id === "MODE-CRAM")){
      companyHasCheckupImpresa = true;
    }
  }

  return (
    <div>
      <div className="dashboardWrapper">
        <WidgetTotalDocsNew
          accountantIdSelected={accountantIdSelected}
          accountantSelected={accountantSelected}
          clientIdSelected={clientIdSelected}
          companySelected={companySelected}          
        />
        {myType !== "PERSON" ? renderAnalytics() : null}

        {/* Renderizzo il widget se e solo se ho il set di prop minime a far scattare
-           * il componenteDidMount diversamente ci possono essere problemi di chiamate non
-           * fatte o chiamate doppie
-           */
          auth &&
              companySelected &&
              studioFind?.taxRegion !== "ES" &&
              accountantSelected &&
              isPermissionDeadlines ? (
              <WidgetCompanyDeadlines
                classNameProp={"cardSkeleton box2_3"}
                goToOtherDeadlinesSubjective={goToOtherDeadlinesSubjective.bind(this)}                
                isDoubleBox={false}
                numberItems={4}
                myType={myType}
              />
            ) : null}

        {myType !== "PERSON" && isPermissionDocumentInvoices && studioFind?.taxRegion !== "ES" && (
          <BoxRecentInvoices
            categoryId={19}
            invoices={passiveInvoices}
            isCentered={passiveInvoices.length === 0}
            isGettingLastEInvoices={isGettingLastEInvoices}            
            isGettingObjectiveDeadlines={false}
            title={<FormattedMessage id="dashboard.invoice" />}
          />
        )}
        {auth &&
            accountantSelected &&
            FEATURE_TOGGLE_ASK === "true" &&
            isPermissionAsk &&
            surveys?.list?.length > 0 ? (
            <WidgetAsk
              accountantSelected={accountantSelected}
              accountantIdSelected={accountantIdSelected}              
              isDoubleBox={false}
              numberItems={4}
            />
          ) : null}
        {/* myType !== "PERSON" ? renderFatturato() : null*/}

        {myType !== "PERSON" ? renderCosti() : null}
        {myType !== "PERSON" ? renderIncassaSubito() : null}

        {/* renderImposte()*/}

      </div>
      {myType === "COMPANY" && companyHasCheckupImpresa && isPermissionCheckup &&
          <div  style={{
            display: "flex",
            flexDirection: "row",
            width: "100%",
            padding: "0 10px"
          }}>
            <div className='companyCheckupWidget'>{renderCheckupWidget(1, "Rating creditizio")}</div>
            <div className='companyCheckupWidget'>{renderCheckupWidget(2, "DSCR")}</div>
            <div className='companyCheckupWidget'>{renderCheckupWidget(3, <FormattedMessage id="checkup.sectorIndices" />)}</div>
          </div> }
      {myType === "COMPANY" &&
          isOnboardingToShow &&
          FEATURE_TOGGLE_TSPAY_ONBOARDING === "true" && (
        <TsPayOnboardingBanner          
          isLanding={false}
        />
      )}
    </div>
  );
};

export default DashCliente;
